"use client";

import { createContext, useState } from "react";
import { StoreI, ListingType, DOWNTOWN } from "~/interfaces";

const initialState: StoreI = {
  app: {
    city: undefined,
    modal: "",
    pathname: "",
    likedListings: 0,
    scrollY: 0,
    calendar: {
      dates: [new Date()],
      isActive: false,
      isFirstActive: true,
    },
    query: "",
    geoCenter: DOWNTOWN,
    radius: 20,
    latitude: "",
    longitude: "",
    refinementList: {
      type: [
        ListingType.ACTIVITY,
        ListingType.EVENT,
        ListingType.BAR,
        ListingType.RESTAURANT,
      ],
      interest_tags: [],
      price_tags: [],
      crowd_tags: [],
    },
    configure: { filters: "" },
    menu: {
      isMainMenuActive: false,
      isFilterActive: false,
      isLikeActive: false,
      isSearchActive: false,
      isBackButtonActive: false,
      isInterestActive: false,
    },
  },
  user: {
    email: "",
    firstName: "",
    lastName: "",
    isAdmin: false,
    isLoggedIn: false,
    role: "",
    latitude: "",
    longitude: "",
  },
};

export const StoreContext = createContext<
  [StoreI, React.Dispatch<React.SetStateAction<StoreI>>]
>([initialState, () => {}]);

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [store, setStore] = useState<StoreI>(initialState);

  return (
    <StoreContext.Provider value={[store, setStore]}>
      {children}
    </StoreContext.Provider>
  );
}
